import { WaterAreaCostBase } from './base/water-area-cost-base';

export class WaterAreaCost extends WaterAreaCostBase { }